export const PICKUP = 'pick_up';
export const DROPOFF = 'drop_off';
